export const SHARE_CONTENT = "Hey!\n" +
  "\n" +
  "I hope you're doing great! I wanted to let you know about Alumni Connect 2026, our upcoming alumni meet, and I'd love for you to join me there.\n" +
  "It's going to be an amazing time to catch up, reminisce about the good old days, and create some new memories together.\n" +
  "\n" +
  "📅 Date: 2-Oct-2026\n" +
  "📍 Venue: MGR Janaki College, Chennai\n" +
  "\n" +
  "You can register here: alumnimeet.maatramtimes.com\n" +
  "\n" +
  "It would be so awesome to see you and hang out again.\n" +
  "Let’s make Alumni Connect 2026 an unforgettable event!\n" +
  "\n" +
  "Can't wait to see you there!";

export const AFTER_REGISTER_SHARE_CONTENT = "Hey!\n" +
  "\n" +
  "I have registered for Alumni Connect 2026, and I'd love for you to join me there.\n" +
  "It's going to be an amazing time to catch up, reminisce about the good old days, and create some new memories together.\n" +
  "\n" +
  "📅 Date: 2-Oct-2026\n" +
  "📍 Venue: MGR Janaki College, Chennai\n" +
  "\n" +
  "You can register here: alumnimeet.maatramtimes.com\n" +
  "\n" +
  "It would be so awesome to see you and hang out again.\n" +
  "Let’s make Alumni Connect 2026 an unforgettable event!\n" +
  "\n" +
  "Can't wait to see you there!";

export const EVENT_CONTENT = {
  title: 'Maatram Alumni Meet 2026',
  description: 'Join us for the Maatram Alumni Meet 2026',
  startTime: new Date('2026-10-02T08:00:00'),
  endTime: new Date('2026-10-02T16:00:00'),
  location: 'MGR Janaki College, Chennai'
};

export const EVENT_DATE = "2nd Oct 2026 - 8:00AM to 4:00PM";
export const LOCATION_URL = "https://maps.app.goo.gl/S7hcx84WYSySdbKz7";
export const LOCATION_NAME = "MGR Janaki College, Chennai";
export const DEPLOYED_URL = "https://alumnimeet.maatramtimes.com/";

//UPI Details
export const UPI_ID = "jayarampeter15@okaxis";
export const UPI_NAME = "Jayaram G S";
// export const UPI_ID = "appuvignesh713-1@okaxis";
// export const UPI_NAME = "Vignesh R";

//Registration end date
export const REGISTRATION_END_DATE = new Date('2026-09-29T23:59:59');
export const ONSITE_REGISTRATION = new Date('2026-10-01T23:59:59');

export const PAGE = {
  ATTENDANCE: "attendance",
  ALLLIST: "all",
}
